import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { NetworkStatus } from '@cbridge-utils/network';
import { INavigationBlockItemRecursive } from '@cbridge-tools/navigation-block';
import { nodeStoreSelector } from '@cbridge-packages/node';
import { generateClientSymbolsServerRoute } from '@cbridge-packages/routing-client-admin';
import { nodeAsClientSymbolNavigationItem } from '../_helpers/nodeAsClientSymbolNavigationItem';

export const clientSymbolNodesSubNavigationPropsSelector = createCachedSelector(
  [
    path(nodeStoreSelector).list(),
    path(nodeStoreSelector).networkStatus(),
  ],
  (nodeList, nodeNetworkStatus) => {
    return {
      items: nodeList.map((node) => {
        const nodeItem = nodeAsClientSymbolNavigationItem(node);
        const nodeServers = node.servers || [];

        return {
          ...nodeItem,
          isExpandedByDefault: true,
          items: nodeServers.map((server) => ({
            label: server.label,
            href: generateClientSymbolsServerRoute(server.value),
            value: String(server.value),
          })),
        } as INavigationBlockItemRecursive;
      }),
      isLoading: nodeNetworkStatus !== NetworkStatus.Done && nodeNetworkStatus !== NetworkStatus.Failed,
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
